import {
  PageBlueprint,
  createFrontendPlugin,
  createRouteRef,
} from '@backstage/frontend-plugin-api';
import { Bell } from 'lucide-react';
import { PageShareTitle } from '../../lib/shareTitle';

export const notificationsRouteRef = createRouteRef();

export const notificationsPage = PageBlueprint.make({
  params: {
    path: '/notifications',
    title: 'Notifications',
    icon: <Bell size={20} strokeWidth={2} />,
    routeRef: notificationsRouteRef,
    noHeader: true,
    loader: () =>
      import('./NotificationsPage').then(m => (
        <PageShareTitle title="Notifications">
          <m.NotificationsPage />
        </PageShareTitle>
      )),
  },
});

/** Custom notifications inbox plugin (replaces the stock notifications page). */
export const regaskNotificationsPlugin = createFrontendPlugin({
  pluginId: 'regask-notifications',
  extensions: [notificationsPage],
});
